import { SET_WELCOME_TOAST } from "./action";
const initialState = {
  showWelcomeToast: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WELCOME_TOAST:
      return {
        ...state,
        showWelcomeToast: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;